import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { get, isArray } from "lodash";
import { postAPI } from "../api/callAPI";

const fetchStoresListByTextAndLatLong = async ({
  endpoint,
  query,
  userLocation,
}) => {
  try {
    // const mResp = await getAPI(endpoint1, "admin/get-active-store-for-admin");
    let reqData = {};
    //   let text = '';
    const lat = get(userLocation, "latitude");
    const lng = get(userLocation, "longitude");
    if (lat && lng) {
      reqData.lat = lat;
      reqData.long = lng;
    }

    if (query && query !== "" && query.length > 2) {
      reqData.text = query;
    }

    const response = await postAPI(
      endpoint,
      "stores-list-by-text-and-lat-long",
      reqData
    );
    // console.log("mResp >>> ", mResp);
    // console.log("response", response?.data);
    if (response?.success) {
      if (isArray(response?.data) && response.data.length > 0) {
        // const storesList = response.data;
        // setStoreSearchList(storesList);
        return response.data;
      }
    }
    return [];
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

const useStoresListByTextAndLatLong = () => {
  //   const {storeItem} = useSelector(state => state.auth);
  //   const storeID = get(storeItem, 'id', 0);
  const { endpoint, userLocation, searchText } = useSelector(
    (state) => state.auth
  );

  // const lat = get(userLocation, "latitude");
  // const lng = get(userLocation, "longitude");

  const queryKey = ["StoresListByTextAndLatLong"];
  return useQuery({
    queryFn: () =>
      fetchStoresListByTextAndLatLong({ endpoint, searchText, userLocation }),
    queryKey,
    // staleTime: 30 * 1000,
  });
};

export default useStoresListByTextAndLatLong;
